﻿window.cObjetBcArticleMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "article"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel article"; }
    this.mGetLib1 = function (option) {
        if (typeof objet.data != 'undefined') { return ((objet.data.objet) ? objet.data.objet : "(aucun nom)") }
        else {
            var txt = "article"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-graduation-cap' title='Article'></i>");
    }

    this.alignItemGrid = "left"
    this.itemTemplateVirtualGridFixed = function (contentElement, option) {
        contentElement.empty()
        if (typeof option == "undefined") option = {}
        if (typeof option.height == 'undefined') option.height = 70
        contentElement.css({ position: "relative" })

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='font-size:130%;font-weight:bold;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + objet.data.objet + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='font-size:80%;width:100%;'><i>" + objet.data.body_txt + "</i></td>").appendTo($Tr)
    }

    this.mGetDossierParent = function () {
        return Me.objet.bddRef.getObjet("bc_dossier", objet.data.id_bc_dossier_parent).data
    }

    this.mGetLstParent = function () {
        var lst = []
        var eleEnCours = objet.data
        while (eleEnCours != null) {
            lst.unshift(eleEnCours)
            eleEnCours = Me.objet.bddRef.getObjet(eleEnCours).objetMetier.mGetDossierParent()
        }
        return lst
    }

    this.mGetLink = function (appli) {
        //if (typeof appli.bcAppli != 'undefined')
        if (typeof appli == "undefined" || appli == null) appli = gestCognoss.mGetAppliCourante()
        if (parametre.isLocalhost) {
            return appli.urlcognoss + "/" + "0/" + objet.data.id_bc_article + "/" + replaceEncodableChars(objet.data.objet) + "/bc"
            //return appli.urlcognoss + "/0/" + objet.data.id_bc_article + "/bc"
        } else {
            return appli.urlcognoss + "/" + appli.code_appli + "/0/" + objet.data.id_bc_article + "/" + replaceEncodableChars(objet.data.objet) + "/bc"
            //return appli.urlcognoss + "/0/" + objet.data.id_bc_article + "/bc"
        }

    }

    this.mGetElementLink = function (appli) {
        if (typeof appli == "undefined") appli = gestCognoss.mGetAppliCourante()
        var $SpanLink = $("<span></span>")
        var $i = $("<i class='fas fa-copy state-hover'></i>").appendTo($SpanLink)
        $i.attr("title", "Cliquer pour copier l'adresse dans le presse-papier")
        var $u = $("<u style='padding-left:5px;'>" + this.mGetLink(appli).reduit(24) + "</u>").appendTo($SpanLink)
        $u.attr("title", this.mGetLink(appli))
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $i, position: "bottom", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'></div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        $i.on("click", function (e) {
            e.stopPropagation()
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(Me.mGetLink(appli)).select();
            document.execCommand("copy");
            $temp.remove();
            mNotify("L'adresse de l'article a été copiée dans le presse-papier", "success", 6000)
        })
        return $SpanLink
    }

    this.mGetLstAppli = function () {
        return gestCognoss.dsAppli.filter(function (o) {
            if (typeof o.bcAppli != 'undefined') {
                return Me.objet.bddRef.mGetArray("bc_article_bc_appli").filter(function (artApp) {
                    return artApp.id_bc_article == objet.data.id_bc_article && o.bcAppli.id_bc_appli == artApp.id_bc_appli
                }).length > 0
            } else { return false }
        })
    }

    this.mGetPaddingPopup = function () { return 20 }

    this.mHasTabPopup = function () {
        return false
    }
    this.mGetWidthPopup = function () {
        return 650
    }
    this.isPopupFullScreen = false
    this.mShowPopup = function (option) {
        if (typeof option == 'undefined') option = {}
        option.fullScreen = false
        option.disableScroll = true
        objet.mShowPopupInterne(option)
    }
    this.contentTemplatePopup = function (contentElement, option) {
        var onHiding = option.pop.option("onHiding")
        option.pop.option("onHiding", function (e) {
            dxUpdate.mSave()
            if (typeof onHiding != 'undefined' && onHiding != null) onHiding(e)
        })
        var dxUpdate = $("<div style='height:100%;'/>").appendTo(contentElement).dxCtrlBcArticleUpdate({
            bddCtrl: Me.objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlBcArticleUpdate("instance")
    }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "calc(100% - 60px)",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        return true
    }

}